import React from 'react'
import Header from '../Layout/Header'
import Lorem from '../Home/HomeSections/Lorem'
import Footer from '../Layout/Footer'
import CommonBanner from './CommonBanner'
import CommonBlog from './CommonBlog'

export default function Common() {
  return (
    <div>
        <Header/>
        <CommonBanner/>
        <CommonBlog/>
        <Lorem/>
        <Footer/>
    </div>
  )
}
